var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"bg",attrs:{"alt":"","src":_vm.image}}),_c('img',{staticClass:"logo",attrs:{"alt":"","src":require("../assets/logo-qiw.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }